module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4FTPH"))).then(() => parcelRequire('5erN3'));